module.exports = __webpack_public_path__ + "img/2lt.18beed93.png";